import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import {
  addAbonement,
  getAbonementsClient,
  commentsAction,
  getStatuses,
  addClientStatus,
  statusAction,
} from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";
import { getClientsList } from "src/store/Slices/ClientsSlice";

const AddStatus = ({ statusModal, setStatusModal, clientInfo, payload, onClose }) => {
  const dateFormatList = ["DD.MM.YYYY"];
  // HELPERS
  const dispatch = useDispatch();
  dayjs.extend(customParseFormat);
  const yesterdayDate = dayjs().subtract(1, "day").format("DD.MM.YYYY");

  // STATE
  const [contactDate, setContactDate] = useState(dayjs());
  const [comment, setComment] = useState();
  const [statusOnce, setStatusOnce] = useState();

  const [task, setTask] = useState(dayjs());
  const statuses = useSelector((state) => state.ClientsSlice.getStatuses);

  // FUNCTIONS\
  //console.log('statusOnce', statusOnce)
  const onClickAddComment = () => {
    if (statusOnce === "undefined") {
      openNotification({
        type: "error",
        message: `Поле "Комментарий" не может быть пустым`,
      });
    } else {
      dispatch(
        addClientStatus({clientId: clientInfo?.id, statusId: statusOnce})
      ).then(() => {
        dispatch(
            statusAction({
                flag: "get",
                value: { userId: clientInfo.id },
            })
        );
        dispatch(getClientsList(payload));
        setStatusModal(false);
      });
    }
  };

  useEffect(() => {
        dispatch(getStatuses())
  }, [statusModal]);

  return (
    <CModal
      alignment="center"
      visible={statusModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setStatusModal(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {"Добавить статус"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Статус</Typography.Title>
              <Select
                style={{ width: "88%" }}
                value={statusOnce}
                onChange={(e) => {
                    setStatusOnce(e)
                }}
                options={statuses}
            />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setStatusModal(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickAddComment} style={{ color: "#fff" }}>
          Добавить
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AddStatus;
